<template>
  <div
    id="event_map"
    ref="map"
    class="grey"
    style="width: 100%;"
    :style="`height: ${height}px;`"
  />
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { inititalCoordinates } from '@/plugins/constants'
export default {
  props: {
    data: {
      type: Object,
      default: () => null
    },
    showMap: {
      type: Boolean,
      default: () => true
    },
    height: {
      type: Number,
      default: () => 400
    },
    mapTypeControl: {
      type: Boolean,
      default: () => false
    },
    drawTrips: {
      type: Boolean,
      default: () => false
    },
    trips: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: () => 'tripsmap'
    },
    drawGeofences: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      map: null, // Google Maps Map entity
      google: null, // Google Maps object
      defaultCenter: null,
      polylines: [],
      marker: null,
      markers: [],
      HtmlMapMarker: null,
      heatmap: null,
      mapGeofences: [],
      mapGeofenceMarkers: []
    }
  },
  computed: {
    ...mapState(['width', 'isLoading']),
    ...mapGetters({
      // Maintenace
      userInitialCoordinates: 'geofences/userHomeDepot', geofenceMarker: 'general/geofenceMarker'
    }),
    tripsColors () {
      return [
        '#DB5461',
        '#FFD9CE',
        '#593C8F',
        '#8EF9F3',
        '#171738',
        '#FA7921',
        '#FE9920',
        '#B9A44C',
        '#566E3D',
        '#0C4767'
      ]
    },
    geofences () {
      return this.$store.state.geofences.list
    }
  },

  watch: {
    showMap (newVal) {
      if (newVal) {
        this.loadMap()
      } else {
        // 
      }
    },
    drawTrips (newVal) {
      if (newVal) {
        this.clearMarker(this.marker)
        this.clearPolylines()
        this.clearMarkers()
        this.clearHeatData()
        if (this.mode === 'tripsmap') {
          this.drawTripsMethod()
        } else if (this.mode === 'heatmap') {
          this.drawHeatMethod()
        }
      } else {
        this.clearMarker(this.marker)
        this.clearMarkers()
        this.clearHeatData()
        this.clearPolylines()
      }
    },

    drawGeofences (_) {
      if (this.drawGeofences) {
        this.drawGeofencesMethod()
      } else {
        this.clearGeofences()
      }
    }
  },

  mounted () {
    if (this.showMap) {
      this.loadMap()
    }
  },

  methods: {
    // Generate random color
    generateColor () {
      // Generate Random COlor
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    loadMap () {
      if (!this.$googlemaps.done) {
        this.$googlemaps
          .load()
          .then((google) => {
            this.google = google
            // to use the label drawer "class" window.google must exist and the file is called to be require
            window.google = google
            this.initMap()
            this.HtmlMapMarker = require('../../../../HtmlMapMarker.js')
            // this.initDrawer()
            // this.startDrawing()
          })
      } else {
        this.google = window.google
        this.initMap()
        this.HtmlMapMarker = require('../../../../HtmlMapMarker.js')
        // this.initDrawer()
        // this.startDrawing()
      }
    },
    /**
     * Initialize Singleton instance of Google maps
     */
    initMap () {
      if (this.data !== null) {
        this.defaultCenter = new this.google.maps.LatLng(this.data.latitude, this.data.longitude)
      } else {
        this.defaultCenter = new this.google.maps.LatLng(inititalCoordinates.latitude, inititalCoordinates.longitude)
      }

      this.map = new this.google.maps.Map(
        this.$refs.map,
        {
          mapTypeId: 'roadmap',
          zoom: 17,
          center: this.defaultCenter,
          disableDefaultUI: true,
          zoomControl: true,
          mapTypeControl: this.mapTypeControl,
          mapTypeControlOptions: {
            position: this.google.maps.ControlPosition.RIGHT_TOP
          }
        }
      )

      setTimeout(() => {
        if (this.marker) {
          this.clearMarker(this.marker)
          this.marker = null
        }
      }, 0)

      const self = this
      setTimeout(() => {
        self.google.maps.event.trigger(self.map, 'resize')
        self.map.setCenter(self.defaultCenter)
        // self.addMarker(new self.google.maps.LatLng(self.defaultCenter.lat(), self.defaultCenter.lng()), 45)
      }, 1000)
    },

    drawPolilyne (points, _index) {
      const color = this.generateColor()
      const polyline = new this.google.maps.Polyline({
        path: points,
        geodesic: true,
        strokeColor: color,
        strokeOpacity: 1.0,
        strokeWeight: 3
      })
      polyline.setMap(this.map)
      return polyline
    },

    addMarker (coordinates, course, colorIndex) {
      const color = this.tripsColors[colorIndex]
      const generatedMarker = `
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 678.398 774.65">
  <g id="Gps" transform="translate(-167.801 -42.995)">
    <path id="Trazado_3353" data-name="Trazado 3353" d="M319.25,82.386c14.766-34.329,63.438-34.329,78.2,0L694.041,771.9a42.566,42.566,0,0,1-39.1,59.385s-2.35-2-7.014-5.709c-30.3-24.075-159.711-120.428-289.32-120.428-148.294,0-296.841,126.136-296.841,126.136a42.566,42.566,0,0,1-39.1-59.385Z" transform="translate(148.648 -13.645)" fill="#fff"/>
    <g id="Trazado_3352" data-name="Trazado 3352" transform="translate(193 37)">
      <path d="M 583.22509765625 721.852783203125 C 582.0289916992188 721.0770874023438 572.4026489257812 714.8676147460938 557.1632690429688 705.9840698242188 C 542.1888427734375 697.2550659179688 518.5744018554688 684.083251953125 491.1134033203125 670.9039916992188 C 460.243408203125 656.0887451171875 430.9034118652344 644.2835693359375 403.9083251953125 635.81640625 C 370.1445007324219 625.2262573242188 339.9691772460938 619.8565673828125 314.2206726074219 619.8565673828125 C 284.771240234375 619.8565673828125 252.1450805664062 624.9771728515625 217.2483367919922 635.076171875 C 189.3419952392578 643.1521606445312 159.9276733398438 654.4122314453125 129.8224182128906 668.5436401367188 C 117.9966659545898 674.0946655273438 106.0344161987305 680.107666015625 94.26799774169922 686.41552734375 C 84.85483551025391 691.4618530273438 75.54499816894531 696.7071533203125 66.59716796875 702.005859375 C 52.34308624267578 710.44677734375 43.52613830566406 716.3577880859375 42.37373733520508 717.1358032226562 C 36.64776992797852 717.1231689453125 31.84622955322266 716.4008178710938 28.10141754150391 714.9883422851562 C 24.47441673278809 713.6204223632812 21.73866653442383 711.5648193359375 19.97008323669434 708.8787231445312 C 18.90983390808105 707.2686767578125 18.16841697692871 705.3897705078125 17.76633262634277 703.2942504882812 C 17.36883354187012 701.2227783203125 17.29116630554199 698.8797607421875 17.5354175567627 696.3304443359375 C 18.01241683959961 691.3515625 19.73758316040039 685.378662109375 22.66300010681152 678.5775756835938 L 280.4702453613281 79.21675109863281 C 282.0089111328125 75.63949584960938 284.02734375 72.38858032226562 286.4693298339844 69.55425262451172 C 288.7909851074219 66.85966491699219 291.4953308105469 64.53949737548828 294.50732421875 62.65816497802734 C 300.2879943847656 59.04758453369141 307.0285034179688 57.13908386230469 314 57.13908386230469 C 320.9714965820312 57.13908386230469 327.7120056152344 59.04758453369141 333.49267578125 62.65816497802734 C 336.5046691894531 64.53949737548828 339.2090148925781 66.85966491699219 341.5306701660156 69.55425262451172 C 343.97265625 72.38858032226562 345.9910888671875 75.63949584960938 347.5297546386719 79.21675109863281 L 605.3370971679688 678.5775756835938 C 608.24658203125 685.3416748046875 609.8236083984375 691.666748046875 610.0242309570312 697.3771362304688 C 610.2257690429688 703.1094360351562 609.02880859375 707.9888305664062 606.4667358398438 711.8799438476562 C 604.3781127929688 715.052001953125 601.3988037109375 717.5106811523438 597.61181640625 719.1876831054688 C 593.6527099609375 720.9407958984375 588.8131103515625 721.8372802734375 583.22509765625 721.852783203125 Z" stroke="none" fill="${color}"/>
      <path d="M 314 57.63916015625 C 307.1222534179688 57.63916015625 300.4733276367188 59.52142333984375 294.7721557617188 63.08233642578125 C 291.8029174804688 64.9368896484375 289.1369018554688 67.22418212890625 286.8481750488281 69.88067626953125 C 284.4394226074219 72.67633056640625 282.4480895996094 75.8839111328125 280.9295043945312 79.414306640625 L 23.12225341796875 678.775146484375 C 20.2174072265625 685.5285034179688 18.50518798828125 691.4509887695312 18.0330810546875 696.3780517578125 C 17.79339599609375 698.8800048828125 17.86883544921875 701.1752319335938 18.25732421875 703.2000122070312 C 18.64697265625 705.2306518554688 19.36376953125 707.0487670898438 20.3875732421875 708.603759765625 C 22.09698486328125 711.1998291015625 24.75164794921875 713.1905517578125 28.27783203125 714.5205078125 C 31.93341064453125 715.8992919921875 36.62310791015625 716.6104736328125 42.2218017578125 716.6353149414062 C 43.79901123046875 715.573974609375 52.51788330078125 709.76220703125 66.3424072265625 701.57568359375 C 75.29632568359375 696.2733154296875 84.6123046875 691.0244750976562 94.03173828125 685.974853515625 C 105.8060302734375 679.662841796875 117.7762451171875 673.6458129882812 129.6099853515625 668.091064453125 C 159.7388305664062 653.9486083984375 189.1779174804688 642.67919921875 217.1093444824219 634.595947265625 C 252.0512390136719 624.4838256835938 284.7242431640625 619.3565673828125 314.2206726074219 619.3565673828125 C 340.0199890136719 619.3565673828125 370.2455749511719 624.7340087890625 404.0579833984375 635.33935546875 C 431.0758361816406 643.8135986328125 460.438232421875 655.627685546875 491.3297424316406 670.4532470703125 C 518.8057250976562 683.6396484375 542.4326782226562 696.8184814453125 557.4149780273438 705.5521850585938 C 572.2196044921875 714.1821899414062 581.7335815429688 720.2924194335938 583.3717651367188 721.3521728515625 C 588.8273315429688 721.3215942382812 593.548828125 720.43994140625 597.4093627929688 718.73046875 C 601.1072387695312 717.093017578125 604.0140991210938 714.6956787109375 606.049072265625 711.60498046875 C 608.552978515625 707.80224609375 609.7222290039062 703.021240234375 609.5244750976562 697.394775390625 C 609.3259887695312 691.74658203125 607.7626953125 685.4819946289062 604.8778076171875 678.775146484375 L 347.0704956054688 79.414306640625 C 345.5519104003906 75.8839111328125 343.5605773925781 72.67633056640625 341.1518249511719 69.88067626953125 C 338.8630981445312 67.22418212890625 336.1969909667969 64.9368896484375 333.2277526855469 63.08233642578125 C 327.5265808105469 59.52142333984375 320.8777465820312 57.63916015625 314 57.63916015625 M 314 56.63916015625 C 327.7857055664062 56.63916015625 341.5714111328125 64.09918212890625 347.9890747070312 79.0191650390625 L 605.79638671875 678.3800048828125 C 616.3004760742188 702.8005981445312 609.6610107421875 722.35302734375 583.0771484375 722.35302734375 C 583.0771484375 722.35302734375 426.8825073242188 620.3565673828125 314.2206726074219 620.3565673828125 C 185.3170776367188 620.3565673828125 42.52685546875 717.635986328125 42.52685546875 717.635986328125 C 15.94293212890625 717.635986328125 11.69940185546875 702.8005981445312 22.20367431640625 678.3800048828125 L 280.0109252929688 79.0191650390625 C 286.4285888671875 64.09918212890625 300.2142944335938 56.63916015625 314 56.63916015625 Z" stroke="none" fill="#707070"/>
    </g>
  </g>
</svg>
`
      const marker = new this.HtmlMapMarker({
        google: this.google,
        position: coordinates,
        map: this.map,
        icon: generatedMarker,
        course: course
      })
      return marker
    },

    addInitMarker (coordinates) {
      return new this.google.maps.Marker({
        position: coordinates,
        map: this.map,
        icon: 'https://integrate.vanguarder.goldenm.dev/static/initFlag.png'
      })
    },

    addEndMarker (coordinates) {
      return new this.google.maps.Marker({
        position: coordinates,
        map: this.map,
        icon: 'https://integrate.vanguarder.goldenm.dev/static/endFlag.png'
      })
    },

    clearMarker (marker) {
      if (marker) {
        marker.setMap(null)
      }
    },

    clearPolylines () {
      for (const i in this.polylines) {
        if (this.polylines[i]) {
          this.polylines[i].setMap(null)
        }
      }
      this.polylines = []
    },

    clearMarkers () {
      for (const i in this.markers) {
        if (this.markers[i]) {
          this.markers[i].setMap(null)
        }
      }
      this.markers = []
    },

    drawTripsMethod () {
      // Generate polylines and bounds
      const bounds = new this.google.maps.LatLngBounds()
      const generalPoints = []
      let colorIndex = 0
      const trips = this.trips.filter((trip) => trip.selected)
      if (trips.length === 0) {
        this.$store.commit('toggleSnackbar', {
          message: this.$i18n.t('trips.messages.selected.empty'),
          color: 'warning'
        })
        return
      }
      for (const i in trips) {
        const trip = trips[i]
        const points = []
        if (i === '0') {
          // Get first message and set as marker
          const message = trip.messages[0]
          const marker = this.addInitMarker(new this.google.maps.LatLng(message.latitude, message.longitude), 0)
          this.markers.push(marker)
        } 
        if (i === (trips.length - 1).toString()) {
          // Get last message and set as marker
          const message = trip.messages[trip.messages.length - 1]
          const marker = this.addEndMarker(new this.google.maps.LatLng(message.latitude, message.longitude))
          this.markers.push(marker)
        }
        for (const j in trip.messages) {
          if (trip.messages[j]) {
            if (trip.messages[j].latitude) {
              const point = {
                lat: trip.messages[j].latitude,
                lng: trip.messages[j].longitude
              }
              // Generate markers (Validate length of trip)
              if (j === '0' && i !== '0') {
                const marker = this.addMarker(new this.google.maps.LatLng(point.lat, point.lng), trip.messages[j].direction, colorIndex)
                this.markers.push(marker)
              } else if (j === (trip.messages.length - 1).toString() && i !== (trips.length - 1).toString()) {
                const marker = this.addMarker(new this.google.maps.LatLng(point.lat, point.lng), trip.messages[j].direction, colorIndex)
                this.markers.push(marker)
              } else if (parseInt(j) % 4 === 0) {
                const marker = this.addMarker(new this.google.maps.LatLng(point.lat, point.lng), trip.messages[j].direction, colorIndex)
                this.markers.push(marker)
              }
              points.push(point)
              generalPoints.push(point)
              bounds.extend(point)
            }
          }
        }
        //  Draw polyline
        this.polylines.push(this.drawPolilyne(points, colorIndex))
        colorIndex++
        if (colorIndex === this.tripsColors.length) {
          colorIndex = 0
        }
      }
      
      this.map.fitBounds(bounds)
    },

    drawHeatMethod () {
      // Generate heat map data
      const bounds = new this.google.maps.LatLngBounds()
      const heatMapData = []
      const trips = this.trips.filter((trip) => trip.selected)
      if (trips.length === 0) {
        this.$store.commit('toggleSnackbar', {
          message: this.$i18n.t('trips.messages.selected.empty'),
          color: 'warning'
        })
        return
      }
      for (const i in trips) {
        const trip = trips[i]
        const points = []
        for (const j in trip.messages) {
          if (trip.messages[j]) {
            if (trip.messages[j].latitude) {
              const point = {
                lat: trip.messages[j].latitude,
                lng: trip.messages[j].longitude
              }
              // Generate heat map data (Validate length of trip)
              if (j === '0' && i !== '0') {
                heatMapData.push({
                  location: new this.google.maps.LatLng(point.lat, point.lng),
                  weigth: 0.5
                })
              } else if (j === (trip.messages.length - 1).toString() && i !== (trips.length - 1).toString()) {
                heatMapData.push({
                  location: new this.google.maps.LatLng(point.lat, point.lng),
                  weigth: 0.5
                })
              } else if (parseInt(j) % 4 === 0) {
                heatMapData.push({
                  location: new this.google.maps.LatLng(point.lat, point.lng),
                  weigth: 0.5
                })
              }
              points.push(point)
              bounds.extend(point)
            }
          }
        }
        this.heatmap = new this.google.maps.visualization.HeatmapLayer({
          data: heatMapData
        })
        this.heatmap.setMap(this.map)
      }
      this.map.fitBounds(bounds)
    },

    clearHeatData () {
      if (this.heatmap) {
        this.heatmap.setMap(null)
      }
      this.heatmap = null
    },
    
    clearGeofences () {
      // Clear map geofences
      for (const i in this.mapGeofences) {
        if (this.mapGeofences[i]) {
          this.mapGeofences[i].setMap(null)
        }
      }
      this.mapGeofences = []
      // Clean mapGeofenceMarkers
      for (const i in this.mapGeofenceMarkers) {
        if (this.mapGeofenceMarkers[i]) {
          this.mapGeofenceMarkers[i].setMap(null)
        }
      }
      this.mapGeofenceMarkers = []
    },
    drawGeofencesMethod () {
      // Filter the geofences that have SERVICE as category
      const geofences = this.geofences.filter((geofence) => geofence.category === 'SERVICE')
      for (const i in geofences) {
        this.drawGeofence(geofences[i])
      }
    },
    drawGeofence (geofence) {
      let overlay
      let marker
      let paths
      const google = this.google
      const bounds = new this.google.maps.LatLngBounds()
      let i

      switch (geofence.mode) {
        case 'LINEAR':
          paths = geofence.path.map((item) => {
            return {
              lat: item.latitude,
              lng: item.longitude
            }
          })
          overlay = new google.maps.Polyline({
            path: paths,
            geodesic: true,
            fillColor: geofence.color,
            strokeColor: geofence.color,
            fillOpacity: 0.3,
            strokeOpacity: 1,
            strokeWeight: 7,
            clickable: false,
            editable: this.isEditting,
            zIndex: 1
          })
          for (i = 0; i < paths.length; i++) {
            bounds.extend(paths[i])
          }
          marker = this.addGeofenceMarker(bounds.getCenter(), geofence.name, this.geofenceMarker)
          break
        case 'RADIAL':
          overlay = new google.maps.Circle({
            center: {
              lat: geofence.path[0].latitude,
              lng: geofence.path[0].longitude
            },
            radius: geofence.path[0].radius,
            fillColor: geofence.color,
            strokeColor: geofence.color,
            fillOpacity: 0.3,
            strokeOpacity: 1,
            strokeWeight: 4,
            clickable: false,
            editable: this.isEditting,
            zIndex: 1
          })

          marker = this.addGeofenceMarker(
            {
              lat: geofence.path[0].latitude,
              lng: geofence.path[0].longitude
            },
            geofence.name,
            this.geofenceMarker
          )

          break
        case 'POLYGON':
          paths = geofence.path.map((item) => {
            return {
              lat: item.latitude,
              lng: item.longitude
            }
          })
          overlay = new google.maps.Polygon({
            paths,
            fillColor: geofence.color,
            strokeColor: geofence.color,
            fillOpacity: 0.3,
            strokeOpacity: 1,
            strokeWeight: 4,
            clickable: false,
            editable: this.isEditting,
            zIndex: 1
          })
          for (i = 0; i < paths.length; i++) {
            bounds.extend(paths[i])
          }
          marker = this.addGeofenceMarker(bounds.getCenter(), geofence.name, this.geofenceMarker)
          break
      }
      this.mapGeofences[geofence.id] = overlay
      this.mapGeofences[geofence.id].setMap(this.map)
      this.mapGeofenceMarkers[geofence.id] = marker
      this.mapGeofenceMarkers[geofence.id].setMap(this.map)
    },
    addGeofenceMarker (coordinates, title = '', icon = null) {
      return new this.google.maps.Marker({
        position: coordinates,
        label: {
          text: title,
          fontWeight: 'bold',
          fontSize: '12px',
          className: 'geozone-marker-label'
        },
        map: this.map,
        title: title,
        labelOrigin: new this.google.maps.Point(26.5, 20),
        anchor: new this.google.maps.Point(26.5, 43),
        icon: icon
      })
    }
  }
}
</script>

<style lang="scss">
</style>